import React from 'react'
import {Switch,Route} from 'react-router-dom'
import Login from './Login'
import SignUp from './Signup'
import Verify from './Verify'

export default function Render() {
	return (
		<Switch>
			<Route exact path="/personal/verify" component={Verify}/>
			<Route exact path="/personal/new" component={SignUp}/>
			<Route exact path="/personal" component={Login}/>
		</Switch>
	)
}
